import React from 'react';

const About = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Sobre ConstructConnect</h1>
      <p className="mb-4">
        ConstructConnect es una plataforma innovadora que conecta a profesionales de la construcción con clientes que buscan servicios de alta calidad. Nuestra misión es simplificar el proceso de encontrar, contratar y gestionar proyectos de construcción y renovación.
      </p>
      <h2 className="text-2xl font-semibold mt-6 mb-4">Nuestra Visión</h2>
      <p className="mb-4">
        Buscamos transformar la industria de la construcción, haciéndola más accesible, transparente y eficiente para todos los involucrados.
      </p>
      <h2 className="text-2xl font-semibold mt-6 mb-4">¿Por qué elegirnos?</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Amplia red de profesionales verificados</li>
        <li>Proceso de contratación simplificado</li>
        <li>Herramientas de gestión de proyectos integradas</li>
        <li>Sistema de reseñas y calificaciones transparente</li>
        <li>Soporte al cliente dedicado</li>
      </ul>
    </div>
  );
};

export default About;